module.exports = __webpack_public_path__ + "static/media/check_icon.81bcb8ab.svg";